export interface PhoneWithChannel {
  ID: number;
  ChannelID?: number;
  CRMClientID?: number;
  ProjectID?: number;
  TenantId: number;
  AnswerTime?: number;
  CallCenter: boolean;
  CallsInLast30Days?: number;
  CampaignID: string;
  CampaignStatus: boolean;
  ChannelMetadataType: string;
  ChannelMetadataTypeID: number;
  ChannelName: string;
  ClientTitle: string;
  DialOption: string;
  Email: string;
  Expose: number;
  ExposeString: string;
  GreetingIn: string;
  GreetingOut: string;
  IsActive: boolean;
  IsManualPhone: boolean;
  OldChannelID?: number;
  PhoneDescription: string;
  PhoneForSms: string;
  PhoneNumber: string;
  PhoneStatus: string;
  ProjectTypeID?: number;
  RecordOption: string;
  RedirectPhone: string;
  RedirectPhoneForUi: string;
  RingbackTone: string;
  StatusID: number;
  TotalCallSeconds: string;
  UseClientPhone: boolean;

  AverageCallSeconds: string;
  NumberOfAnsweredCalls: number;
  NumberOfMissedCalls: number;
}

export enum PhoneStatus {
  None = 0,
  Active = 1,
  InActive = 2,
  Released = 3
}
